'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ItemRemote = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemRemote = exports.ItemRemote = {
    fetchItemsByIds: function fetchItemsByIds(_ref) {
        var authToken = _ref.authToken,
            deployment = _ref.deployment,
            itemIds = _ref.itemIds;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<ITEM-API>spa/small/items', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.send({ ids: itemIds });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)(resolve, reject, err, response);
            });
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/remote/item.js
// module id = B1jV
// module chunks = 46